import React, { FC, useState, ChangeEvent } from 'react'
import styles from '../../styles/styles.module.css'

interface PasswordInputToggleProps {
  value: string
  onChange: (value: string) => void
  errorMsg?: React.ReactElement | string
  maxLength?: number
  placeholder?: string
  autoComplete?: string
}

const PasswordInputToggle: FC<PasswordInputToggleProps> = ({
  value,
  onChange,
  errorMsg,
  maxLength = 100,
  placeholder = 'Пароль',
  autoComplete = 'new-password',
}) => {
  const [visible, setVisible] = useState(false)

  const toggleVisibility = () => {
    setVisible((v) => !v)
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value
    const filtered = raw.replace(/[А-Яа-яЁё]/g, '')
    onChange(filtered)
  }

  return (
    <div className="inputWrapper">
      <div className="password-wrapper" data-password-wrapper>
        <input
          type={visible ? 'text' : 'password'}
          className="input"
          placeholder={placeholder}
          autoComplete={autoComplete}
          maxLength={maxLength}
          value={value}
          onChange={handleChange}
        />
        <span
          className={`password-toggle-icon${visible ? ' visible' : ''}`}
          data-password-toggle
          onClick={toggleVisibility}
          role="button"
        />
      </div>
      {/* Ошибка внутри inputWrapper, под password-wrapper */}
      {errorMsg && (
        <div className={styles.errorMsg} data-i18n={errorMsg}>
          {errorMsg}
        </div>
      )}
    </div>
  )
}

export default PasswordInputToggle
